import { AgentMutations } from '@sales-app/graphql/mutations/agent.mutations'
import { AgentQueries } from '@sales-app/graphql/queries/agent.queries'
import { Status } from '@sales-app/types/Agent'
import clsx from 'clsx'
import React, { useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import { useUserContext } from '@/context'
import { useGraphql, useGraphqlMutation } from '@/hooks/useGraphql'

export const AgentStatus = () => {
  const { user } = useUserContext()
  const { data, refetch } = useGraphql<AgentQueries.GET_AGENT.Response>(
    AgentQueries.getAgentDetails.name,
    AgentQueries.getAgentDetails(),
    { id: user?.agent?.id },
    { enabled: !!user?.agent?.id },
  )

  const { mutate } = useGraphqlMutation(AgentMutations.updateAgentStatus(), {
    onSuccess: () => {
      refetch()
    },
  })
  const status = data?.agent?.currentStatus || Status.Unavailable

  const [toggleStatusOptions, setToggleStatusOptions] = useState(false)
  const statusOptionsRef = useRef<HTMLDivElement>(null)

  useClickAway(statusOptionsRef, () => setToggleStatusOptions(false))

  function handleClickToggle() {
    setToggleStatusOptions((prev) => !prev)
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case Status.Available:
        return 'bg-green-200'
      case Status.Busy:
        return 'bg-yellow-200'
      case Status.Unavailable:
        return 'bg-text-semantic-error'
      default:
        return 'bg-action-secondary'
    }
  }

  const statusOptions = Object.values(Status)

  const updateStatus = (status: Status) => {
    if (user?.agent?.id) {
      mutate({ agentStatus: { agentId: user?.agent?.id, status } })
    }
  }

  return (
    <>
      {data && data.agent && (
        <div
          className="relative flex w-48 flex-col items-center rounded-t-2xl border bg-bg-accent-avocado px-4 py-2  border-secondary"
          onClick={handleClickToggle}
          ref={statusOptionsRef}
          role="presentation"
        >
          <div className="flex w-full items-center">
            <div
              className={`mr-3 w-4 rounded-full border-2 border-secondary ${getStatusColor(status)}`}
              style={{ height: '14px' }}
            ></div>
            <div className="w-full text-bg-primary">{status}</div>
          </div>

          <div
            className={clsx(
              'flex flex-col w-full border-t border-action-accent',
              toggleStatusOptions ? 'visible mt-2' : 'invisible h-0',
            )}
          >
            <p className="my-2 leading-140 text-grey-100">Update your status</p>
            <div className="flex w-full flex-col">
              {statusOptions.map((s, i) => {
                return (
                  <div
                    className="my-2 flex w-full cursor-pointer items-center justify-center rounded-md bg-bg-primary px-4 py-3"
                    key={i}
                    onClick={() => updateStatus(s)}
                    role="presentation"
                  >
                    <div
                      className={`mr-3 w-4 rounded-full border-2 border-secondary ${getStatusColor(s)}`}
                      style={{ height: '14px' }}
                    ></div>
                    <div className="w-full">{s}</div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
